import React from 'react';
import { motion } from 'framer-motion';
const PRODUCT_URL = 'https://vitalizateahora.com/cart/52015108358375:1';
interface CTAButtonProps {
  text?: string;
  subtitle?: string;
}
export function CTAButton({
  text = 'QUIERO DORMIR MEJOR AHORA',
  subtitle
}: CTAButtonProps) {
  return <div className="flex flex-col items-center gap-2" data-id="element-13">
      <motion.a href={PRODUCT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.03,
      boxShadow: '0 0 40px rgba(212, 168, 83, 0.5)'
    }} whileTap={{
      scale: 0.98
    }} className="inline-block px-8 py-4 md:px-12 md:py-5 rounded-full font-semibold text-base md:text-lg tracking-wide text-[#0B1026] transition-all duration-300 gold-glow" style={{
      background: 'linear-gradient(135deg, #D4A853, #E8C478)'
    }} data-id="element-14">
        {text}
      </motion.a>
      {subtitle && <p className="text-sm text-gray-400" data-id="element-15">{subtitle}</p>}
    </div>;
}